import React from "react";

const LotOfPain = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_939_534)">
                <ellipse cx="24" cy="24" rx="22.9787" ry="23" fill="white" />
                <path
                    d="M24.051 47.994C10.7663 48.2218 0.00982094 37.0429 6.59293e-06 24.0147C-0.00980775 10.9864 10.9391 -0.0295122 23.8469 -6.31612e-05C36.9706 0.0293859 47.8528 10.1265 47.9902 23.9244C48.1453 37.6614 36.6468 48.2807 24.051 47.994ZM24.1021 45.9974C35.4867 46.3547 46.1628 36.7111 46.0293 23.7594C45.9635 17.9237 43.5839 12.3529 39.4133 8.2713C35.2428 4.18972 29.6226 1.9314 23.788 1.99266C11.1903 2.09475 1.93147 12.7219 1.95502 24.1776C1.98054 35.2681 11.5868 46.445 24.1021 45.9974Z"
                    fill="black"
                />
                <path
                    d="M39.4654 25.5775C37.795 28.3712 35.1196 29.1526 32.3362 27.7371C31.0015 27.0578 29.7982 26.1665 29.2231 24.6724C28.7658 23.4846 28.5675 22.3165 29.3468 21.0993C30.4951 20.4946 31.608 21.0993 32.6091 21.5331C35.0175 22.5619 37.5535 23.4356 39.4654 25.5775Z"
                    fill="black"
                />
                <path
                    d="M8.5188 25.7385C11.2217 22.7327 14.6626 21.5842 18.2252 20.8303C19.3499 21.7059 19.2557 22.7308 19.0692 23.6967C18.7689 25.2477 17.76 26.3667 16.5018 27.2306C13.6223 29.1899 10.8271 28.7286 8.5188 25.7385Z"
                    fill="black"
                />
                <path
                    d="M30.0082 38.4821C25.9412 36.9114 21.9939 36.7936 17.8502 38.5743L16.4939 36.1791C17.1986 35.7531 17.65 35.3938 18.1663 35.1877C21.931 33.7408 25.7233 33.6485 29.5077 35.0993C31.4961 35.863 31.5825 36.3971 30.0082 38.4821Z"
                    fill="black"
                />
                <path
                    d="M18.029 15.2978C14.6725 18.7375 10.678 20.5986 5.96713 21.0659C5.40379 20.151 5.39005 19.5326 6.47551 19.3736C9.09881 18.9865 11.6054 18.0288 13.8186 16.5681C14.645 16.0301 15.3889 15.3528 16.1544 14.7324C16.8257 14.1964 17.3675 14.3535 18.029 15.2978Z"
                    fill="black"
                />
                <path
                    d="M42.3272 19.5051C42.6864 20.3807 42.5647 20.9815 41.7894 20.9501C40.7164 20.9097 39.6524 20.7377 38.6213 20.4377C35.3296 19.456 32.3205 17.9914 30.1182 15.2468C30.5893 14.4615 31.0643 14.1434 31.765 14.7893C34.7348 17.5202 38.3151 18.9122 42.3272 19.5051Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_939_534">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LotOfPain;
